import { useAppDispatch } from "./index"
import { logout as reduxLogout } from "../../redux/slices/auth"

export const useLogout = () => {
  const dispatch = useAppDispatch()

  const handleLogout = async () => {
    // Always clear the Redux state first
    dispatch(reduxLogout())

    if (process.env.NODE_ENV === "production") {
      // In production, redirect to Auth0 logout
      window.location.href = "https://app.bankingbridge.com/auth0/logout"
    }
  }

  return handleLogout
}
